<div class="flex flex-col gap-md">
  @if (showMatch()) {
    <div [formGroup]="group()">
      <lib-radio-button
        [id]="idPrefix() + '_match'"
        [formGroup]="group()"
        inputFormControlName="match"
        [label]="'reflection_conditions_match_label' | transloco"
        [options]="matchOptions()" />
    </div>
  }

  @for (row of rows(); track row.group) {
    <div
      [formGroup]="row.group"
      class="grid grid-cols-1 items-start gap-md rounded-lg border border-neutral-200 p-md md:grid-cols-[1fr_1fr_1fr_auto]">
      <div>
        @if (fieldOptions().length) {
          <lib-select
            inputFormControlName="field_key"
            [id]="idPrefix() + '_field_' + row.index"
            name="field_key"
            [label]="'reflection_condition_field' | transloco"
            [required]="true"
            [options]="fieldOptions()"
            [selectedKeyName]="'label'"
            [selectedKeyValue]="'value'"
            [hasSearch]="true"
            [searchPlaceholder]="'type_to_search_placeholder' | transloco"
            (changeOption)="onFieldChange(row.index)" />
        } @else {
          <p class="text-xs text-neutral-500">
            {{ 'reflection_param_no_options' | transloco }}
          </p>
        }
      </div>

      <div>
        @if (row.operatorOptions.length) {
          <lib-select
            inputFormControlName="operator"
            [id]="idPrefix() + '_operator_' + row.index"
            name="operator"
            [label]="'reflection_condition_operator' | transloco"
            [required]="true"
            [options]="row.operatorOptions"
            [selectedKeyName]="'label'"
            [selectedKeyValue]="'value'"
            (changeOption)="onOperatorChange(row.index)" />
        }
      </div>

      <div>
        @if (row.showValue) {
          @switch (row.valueKind) {
            @case (ConditionValueKind.NUMBER) {
              <lib-input
                inputFormControlName="value"
                [id]="idPrefix() + '_value_' + row.index"
                type="number"
                name="value"
                [label]="'reflection_condition_value' | transloco"
                [required]="true" />
            }
            @case (ConditionValueKind.DATE) {
              @if (row.pickerGroup; as picker) {
                <div [formGroup]="picker">
                  <lib-date-picker
                    inputFormControlName="value"
                    [id]="idPrefix() + '_value_' + row.index"
                    name="value"
                    [label]="'reflection_condition_value' | transloco"
                    [placeholder]="'reflection_condition_value' | transloco"
                    [required]="true"
                    [showTime]="false"
                    [lang]="'current_lang' | transloco"
                    [closeButtonText]="'date_picker_close_button' | transloco"
                    [applyButtonText]="
                      'date_picker_apply_button' | transloco
                    " />
                </div>
              }
            }
            @case (ConditionValueKind.DATE_TIME) {
              @if (row.pickerGroup; as picker) {
                <div [formGroup]="picker">
                  <lib-date-picker
                    inputFormControlName="value"
                    [id]="idPrefix() + '_value_' + row.index"
                    name="value"
                    [label]="'reflection_condition_value' | transloco"
                    [placeholder]="'reflection_condition_value' | transloco"
                    [required]="true"
                    [showTime]="true"
                    [lang]="'current_lang' | transloco"
                    [closeButtonText]="'date_picker_close_button' | transloco"
                    [applyButtonText]="
                      'date_picker_apply_button' | transloco
                    " />
                </div>
              }
            }
            @case (ConditionValueKind.SELECT) {
              @if (row.valueOptions.length) {
                <lib-select
                  inputFormControlName="value"
                  [id]="idPrefix() + '_value_' + row.index"
                  name="value"
                  [label]="'reflection_condition_value' | transloco"
                  [required]="true"
                  [options]="row.valueOptions"
                  [selectedKeyName]="'label'"
                  [selectedKeyValue]="'value'" />
              }
            }
            @case (ConditionValueKind.MULTI_SELECT) {
              @if (row.valueOptions.length) {
                <lib-multi-select
                  inputFormControlName="value"
                  [id]="idPrefix() + '_value_' + row.index"
                  name="value"
                  [label]="'reflection_condition_value' | transloco"
                  [required]="true"
                  [options]="row.valueOptions"
                  [selectedKeyName]="'label'"
                  [selectedKeyValue]="'value'" />
              }
            }
            @case (ConditionValueKind.USER) {
              @if (row.userPicker; as picker) {
                @for (key of [picker.key]; track key) {
                  <div [formGroup]="picker.group">
                    <lib-multi-lookup-field
                      [id]="idPrefix() + '_value_' + row.index"
                      inputFormControlName="value"
                      [name]="'value_' + row.index"
                      [label]="'reflection_condition_value' | transloco"
                      [placeholder]="'reflection_users_placeholder' | transloco"
                      [required]="true"
                      [size]="picker.size"
                      [apiUrl]="userLookupApi"
                      [selectedOption]="picker.selected"
                      [labelValueAssignList]="userLookupAssignList()"
                      [lang]="'current_lang' | transloco"
                      [searchPlaceholder]="
                        'type_to_search_placeholder' | transloco
                      "
                      [detailsNotFoundLabel]="
                        'details_not_found_label' | transloco
                      "
                      [addNewAssignLabel]="
                        'multi_lookup_field_add_new_assign_label' | transloco
                      "
                      [noSearchResultLabel]="
                        'user_dropdown_input_no_data_label' | transloco
                      " />
                  </div>
                }
              }
            }
            @default {
              <lib-input
                inputFormControlName="value"
                [id]="idPrefix() + '_value_' + row.index"
                type="text"
                name="value"
                [label]="'reflection_condition_value' | transloco"
                [required]="true" />
            }
          }
          <lib-validation-message
            [lang]="'current_lang' | transloco"
            [control]="'value'" />
        }
      </div>

      <div class="flex md:pt-lg">
        <lib-button
          [id]="idPrefix() + '_remove_' + row.index"
          [label]="'reflection_remove_row' | transloco"
          [btnClass]="'py-xs px-md text-sm rounded-md text-destructive-700 bg-white font-medium border border-destructive-300'"
          (click)="removeRule(row.index)" />
      </div>
    </div>
  }

  <div>
    <lib-button
      [id]="idPrefix() + '_add'"
      [label]="'reflection_conditions_add_rule' | transloco"
      [btnClass]="'py-xs px-md text-sm rounded-md text-primary-700 bg-white font-medium border border-primary-300'"
      (click)="addRule()" />
  </div>
</div>
